import React from 'react'
import styled from 'styled-components'
import travelImage from '../images/travel.svg'
import eatImage from '../images/eat.svg'
import petlImage from '../images/dogs.svg'
import entImage from '../images/books.svg'
import otherslImage from '../images/others.svg'
import CategoryCard from '../components/CategoryCard'

const Wrapper = styled.div`
  background: #b4e4f9;
  padding: 1.2em 0 1em;
  .title,
  ul {
    max-width: ${props => props.theme.sizes.maxWidth};
    margin-left: auto;
    margin-right: auto;
    padding: 0 20px;
  }
  .title {
    font-size: 16px;
    letter-spacing: 1px;
    color: ${props => props.theme.colors.highlight};
  }
  ul {
    display: flex;
    justify-content: space-between;
    margin-top: 0.5em;
    list-style: none;
  }
  @media screen and (min-width: ${props => props.theme.responsive.small}) {
    .title {
      font-size: 20px;
    }
  }
  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    padding: 2.5em 0 1.5em;
    ul {
      margin-top: 1em;
    }
    .title {
      font-size: 23px;
    }
  }
`

const CategoryList = () => {
  return (
    <Wrapper>
      <div className="title webfont">CATEGORY</div>
      <ul>
        <CategoryCard
          title="TRAVEL"
          imageSrc={travelImage}
          url="/tag/travel/"
        />
        <CategoryCard title="EAT" imageSrc={eatImage} url="/tag/eat/" />
        <CategoryCard title="PET" imageSrc={petlImage} url="/tag/pet/" />
        <CategoryCard title="ENTAME" imageSrc={entImage} url="/tag/ent/" />
        <CategoryCard
          title="OTHERS"
          imageSrc={otherslImage}
          url="/tag/others/"
        />
      </ul>
    </Wrapper>
  )
}
export default CategoryList
